import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { OrganizationRiderDetail } from '@uzurv/clara';
import { TabService } from '../../../services/tab/tab.service';
import { RiderDetailTabs } from '../../../pages/organization-rider-detail/organization-rider-detail.page';

export interface RiderHasBalanceDialogData {
  organizationRider: OrganizationRiderDetail;
}

@Component({
  selector: 'app-rider-has-balance-dialog',
  templateUrl: './rider-has-balance-dialog.component.html',
  styleUrls: ['./rider-has-balance-dialog.component.scss']
})
export class RiderHasBalanceDialogComponent {
  constructor(
    private dialogRef: MatDialogRef<RiderHasBalanceDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: RiderHasBalanceDialogData,
    private tabService: TabService
  ) {}

  handleContinueToItinerary() {
    this.dialogRef.close(false);
  }

  handleMakePayment() {
    this.tabService.addTab({
      name: `Rider: ${this.data.organizationRider.name}`,
      route: `/riders/details/${this.data.organizationRider.organizationRiderId}/organization/${this.data.organizationRider.organizationId}`,
      svgIcon: 'uz_rider',
      navigationExtras: { queryParams: { subTab: RiderDetailTabs.PAYMENTS } }
    });
    this.dialogRef.close(true);
  }
}
